import React from 'react'

import { StyledMessengerButton } from 'component-library/buttons/MessengerButton/MessengerButton.styled'
import { IconMessenger } from 'component-library/icons/IconMessenger/IconMessenger'

export interface Props {
    link: string
}

export const MessengerButton: React.FC<Props> = ({ link }) => {
    return (
        <StyledMessengerButton to={link}>
            <IconMessenger />
            Send us a message
        </StyledMessengerButton>
    )
}
